import { collection, getDocs, limit, orderBy, query } from "firebase/firestore";
import { ContactMe } from "../../models/ContactMe";
import { firestore } from "../../utils/firebase";
import { IContactMeRepository } from "./IContactMeRepository";

export class ContactMeFirebaseRepository extends IContactMeRepository {
    getLatestContactMe: () => Promise<ContactMe | undefined> = async (): Promise<ContactMe | undefined> => {
        const q = query(
            collection(firestore, "contact-me"),
            orderBy("createdAt", "desc"),
            limit(1)
        );
        const doc = await getDocs(q);
        if (!doc.empty) {
            return doc.docs[0].data() as ContactMe;
        }
    }

}